import axios from "axios";
import MaterialBox from "../../components/MaterialBox"
import MaterialButton from "../../components/MaterialButton"
import { useSnackbar } from "../../context/popup";
import "./index.css"
import { Divider } from "@mui/material";

const UnknownPage = () => {

    const { showSnackbar } = useSnackbar();
    const token = sessionStorage.getItem('token')
    
    //signing out API call
    const signOut = async () => {
        if(token){
            try {
        
            if (!token) {
                showSnackbar('No token found for logout',"error");
            }
        
            //  Call Logout API
            const response = await axios.post(process.env.REACT_APP_LOGOUT_API_BASE_URL,
                {},
                {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
                }
            )  
            const data = response.data    
            if (data?.success === false) {
                showSnackbar(data.message || 'Logout API call failed',"error")
                return
            }    
            showSnackbar(data.message || 'Logged out successfully',"success");    
            //  Delay for UX
    
            setTimeout(async () => {
                //  Clear storage
                sessionStorage.clear()
                localStorage.clear()    
                //  Clear cookies
                document.cookie.split(';').forEach(cookie => {
                document.cookie = cookie
                    .replace(/^ +/, '')
                    .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
                })    
                //  Clear cache (PWA / SW)
                if ('caches' in window) {
                const cacheNames = await caches.keys()
                await Promise.all(cacheNames.map(name => caches.delete(name)))
                }    
                //  HARD redirect (kills memory + cache)
                window.location.replace(process.env.REACT_APP_APP_URL ||
                '/'
                )
    
            }, 500)
    
            } catch (error) {
            console.error('Logout failed:', error)
            showSnackbar(error.message || 'Something went wrong during logout',"error");
            }
        }
        else{
            window.location.href = process.env.REACT_APP_APP_URL
        }

    }
  return (
    <>
    <MaterialBox
    minHeight="100vh"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    textAlign="center"
    px={2}
    >
        <MaterialBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        >
            <div className="error-404-wrapper">
            <div className="error-404-text">
                <span className="digit">4</span>

                <div className="magnifier-zero">
                <div className="lens">
                    <div className="lens-reflection"></div>
                </div>
                <div className="handle"></div>
                </div>

                <span className="digit">4</span>
            </div>
            </div>
            <MaterialBox>
                <h1 className="error-title">Page Not Found</h1>
                <p className="error-description">
                    Sorry, We couldn't find the page you are looking for
                </p>
                <Divider/>
            </MaterialBox>
        </MaterialBox>
        {/* Button */}
        <MaterialBox mt={3} width={{ xs: "80%", sm: "280px" }}>
            <MaterialButton
            variant="gradient"
            color="dark"
            fullWidth
            onClick={signOut}
            >
            Back to Home
            </MaterialButton>
        </MaterialBox>
    </MaterialBox>
    </>
  )
}

export default UnknownPage